import css from './login.module.scss';

import { FC, InputHTMLAttributes, ComponentProps } from 'react';

import Button from 'core/ui/Button';

export const Input: FC<InputHTMLAttributes<HTMLInputElement>> = props => (
  <input className={css.textInput} {...props} />
);

type TButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'link' | 'onClick'
> & { onClick?: () => void };

export const SubmitButton: React.FC<TButtonProps> = props => (
  <Button {...props} type="submit" children="Login" onClick={() => undefined} />
);
